/* Refresh Cars — Product Reviews renderer
 * Lee assets/reviews.json (generado desde Judge.me API) y renderiza reseñas
 * filtradas por product.id, con paginación incremental y formulario modal.
 */
(function () {
  'use strict';

  var PAGE_SIZE = 6;
  var cache = null;
  var cachePromise = null;

  function loadReviews(url) {
    if (cache) return Promise.resolve(cache);
    if (cachePromise) return cachePromise;
    cachePromise = fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) { cache = data; return data; })
      .catch(function () { return { reviews: {}, summary: {} }; });
    return cachePromise;
  }

  function escapeHTML(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function starsHTML(rating) {
    var r = Math.round(rating);
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<span class="star ' + (i <= r ? 'star--filled' : '') + '">★</span>';
    }
    return out;
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return '';
    var meses = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    return m[3] + ' ' + meses[parseInt(m[2],10)-1] + ' ' + m[1];
  }

  function initials(name) {
    var parts = String(name || 'C').trim().split(/\s+/);
    return ((parts[0] || '')[0] || 'C').toUpperCase() + ((parts[1] || '')[0] || '').toUpperCase();
  }

  function reviewCardHTML(rv) {
    return '' +
      '<article class="review">' +
        '<div class="review__head">' +
          '<div class="review__avatar" aria-hidden="true">' + escapeHTML(initials(rv.n)) + '</div>' +
          '<div class="review__who">' +
            '<div class="review__name">' + escapeHTML(rv.n) +
              (rv.v ? ' <span class="review__verified" title="Compra verificada">✓ verificada</span>' : '') +
            '</div>' +
            '<div class="review__date">' + escapeHTML(fmtDate(rv.d)) + '</div>' +
          '</div>' +
          '<div class="review__stars" aria-label="' + rv.r + ' de 5 estrellas">' + starsHTML(rv.r) + '</div>' +
        '</div>' +
        (rv.t ? '<h3 class="review__title">' + escapeHTML(rv.t) + '</h3>' : '') +
        '<p class="review__body">' + escapeHTML(rv.b) + '</p>' +
      '</article>';
  }

  function renderSummary(section, list) {
    var avg = 0, count = list.length;
    if (count > 0) {
      var sum = 0;
      for (var i = 0; i < count; i++) sum += (list[i].r || 0);
      avg = sum / count;
    }
    var avgStr = (Math.round(avg * 10) / 10).toFixed(1);

    var sAvg = section.querySelector('[data-rc-summary-avg]');
    var sCount = section.querySelector('[data-rc-summary-count]');
    var sStars = section.querySelector('[data-rc-summary-stars]');
    if (sAvg) sAvg.textContent = count > 0 ? avgStr : '—';
    if (sCount) sCount.textContent = count;
    if (sStars) sStars.innerHTML = count > 0 ? starsHTML(avg) : starsHTML(5);

    // Sync mini-summary under title
    var pid = section.getAttribute('data-product-id');
    document.querySelectorAll('[data-rc-rating-summary][data-product-id="' + pid + '"]').forEach(function (el) {
      var a = el.querySelector('[data-rc-rating-avg]');
      var c = el.querySelector('[data-rc-rating-count]');
      var st = el.querySelector('.rating-stars');
      if (a) a.textContent = count > 0 ? avgStr : a.textContent;
      if (c) c.textContent = count;
      if (st && count > 0) st.innerHTML = starsHTML(avg);
    });

    // Enriquecer el Product JSON-LD con aggregateRating si tenemos reseñas
    // reales en el JSON y no hay metafield Judge.me poblado server-side.
    // Inyectar el AggregateRating DENTRO del Product (no standalone) para
    // que Google muestre estrellas en SERP. SRP: no creamos JSON-LD nuevo,
    // mutamos el existente.
    if (count >= 1) {
      var ldScript = document.getElementById('rc-product-jsonld');
      if (ldScript) {
        try {
          var ldData = JSON.parse(ldScript.textContent);
          // Si ya hay aggregateRating con reviewCount > 0, no sobreescribir
          // (server-side metafield Judge.me tiene preferencia).
          var hasRating = ldData && ldData.aggregateRating &&
                          parseInt(ldData.aggregateRating.reviewCount, 10) > 0;
          if (!hasRating) {
            ldData.aggregateRating = {
              '@type': 'AggregateRating',
              ratingValue: avgStr,
              reviewCount: String(count),
              bestRating: '5',
              worstRating: '1'
            };
            ldScript.textContent = JSON.stringify(ldData);
          }
        } catch (e) { if (window.console) console.warn('JSON-LD parse failed', e); }
      }
    }
  }

  function initSection(section) {
    var pid = section.getAttribute('data-product-id');
    var handle = section.getAttribute('data-product-handle');
    var url = section.getAttribute('data-reviews-url');
    var listEl = section.querySelector('[data-rc-reviews-list]');
    var emptyEl = section.querySelector('[data-rc-empty]');
    var footerEl = section.querySelector('[data-rc-footer]');
    var moreBtn = section.querySelector('[data-rc-load-more]');
    var shown = 0;
    var all = [];

    function renderNext() {
      var next = all.slice(shown, shown + PAGE_SIZE);
      if (next.length === 0) return;
      var html = '';
      for (var i = 0; i < next.length; i++) html += reviewCardHTML(next[i]);
      listEl.insertAdjacentHTML('beforeend', html);
      shown += next.length;
      if (shown >= all.length) footerEl.hidden = true;
    }

    function rcLoadAndRender() {
    loadReviews(url).then(function (data) {
      var allRaw = (data.reviews && (data.reviews[handle] || data.reviews[pid])) || [];
      if (allRaw.length === 0) {
        // Si reviews.json está vacío, comprobar si el metafield del producto tiene
        // rating > 0. Si lo tiene, usar ese para mantener consistencia con el
        // mini-summary del titular (evita que arriba diga "4.42/5 · 80 reseñas"
        // y abajo "—/5 basado en — reseñas" — eso destruye el trust).
        var mini = document.querySelector('[data-rc-rating-summary][data-product-id="' + pid + '"]');
        var miniAvg = mini && mini.querySelector('[data-rc-rating-avg]');
        var miniCount = mini && mini.querySelector('[data-rc-rating-count]');
        var avgN = miniAvg ? parseFloat(miniAvg.textContent) || 0 : 0;
        var countN = miniCount ? parseInt(miniCount.textContent, 10) || 0 : 0;
        if (countN > 0) {
          // Hidrata el summary con los datos del metafield.
          var sAvg2 = section.querySelector('[data-rc-summary-avg]');
          var sCount2 = section.querySelector('[data-rc-summary-count]');
          var sStars2 = section.querySelector('[data-rc-summary-stars]');
          if (sAvg2) sAvg2.textContent = (Math.round(avgN * 10) / 10).toFixed(1);
          if (sCount2) sCount2.textContent = countN;
          if (sStars2) sStars2.innerHTML = starsHTML(avgN);
          // Mensaje suave: tenemos rating agregado pero no cards individuales aún.
          if (emptyEl) {
            emptyEl.hidden = false;
            emptyEl.textContent = 'Tenemos ' + countN + ' valoración' + (countN === 1 ? '' : 'es') + ' agregadas. ¡Escribe la primera con foto!';
          }
        } else {
          if (emptyEl) emptyEl.hidden = false;
          renderSummary(section, []);
        }
        return;
      }
      renderSummary(section, allRaw);
      all = allRaw.slice(0, 6);
      renderNext();
    });
    }
    // Diferir la descarga de reviews.json (118KB) hasta que la sección se acerca
    // al viewport: el bloque de reseñas vive al fondo del PDP, así no penaliza el LCP.
    if ('IntersectionObserver' in window) {
      var rcIO = new IntersectionObserver(function (entries, obs) {
        if (entries.some(function (e) { return e.isIntersecting; })) { obs.disconnect(); rcLoadAndRender(); }
      }, { rootMargin: '600px 0px' });
      rcIO.observe(section);
    } else {
      rcLoadAndRender();
    }

    if (moreBtn) moreBtn.addEventListener('click', renderNext);

    // Form modal
    var modal = section.querySelector('[data-rc-form-modal]');
    var openBtns = section.querySelectorAll('[data-rc-open-form]');
    var closeBtns = section.querySelectorAll('[data-rc-close-form]');
    openBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    closeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });

    // Auto-open if contact form just posted
    if (modal && window.location.hash === '#contact_form-success') {
      modal.hidden = false;
    }
  }

  function init() {
    document.querySelectorAll('[data-rc-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
